import { t, Trans } from '@lingui/macro'
import { Select } from '@xooom/ui'
import { usePlanLocations } from 'context'
import {
  FlexAlignItemsCenter,
  InputField,
  Loading,
  Option
} from 'webbook-airways'

export default function InputFieldPlanLocations({
  required,
  value,
  onChange,
  withoutall,
  withoutNone
}) {
  const { loading, planLocations } = usePlanLocations()

  if (loading) {
    return (
      <FlexAlignItemsCenter css={{ justifyContent: 'center', minWidth: 150 }}>
        <Loading size={20} container={false} noTimeout />
      </FlexAlignItemsCenter>
    )
  }
  return (
    <InputField
      noEmpty
      required={required}
      css={{ minWidth: 150 }}
      label={<Trans>Staff Location</Trans>}
      value={value}
      onChange={onChange}
    >
      {!withoutall && <Option value="all">{t`All`}</Option>}
      {!withoutNone && <Option value={0}>{t`No location`}</Option>}
      {planLocations.map(location => {
        return (
          <Option
            key={location.plan_location_id}
            value={location.plan_location_id}
          >
            {location.place}
          </Option>
        )
      })}
    </InputField>
  )
}

export function SelectPlanLocations({
  required,
  value,
  onChange,
  withoutall,
  withoutNone
}) {
  const { loading, planLocations } = usePlanLocations()

  if (loading) {
    return (
      <FlexAlignItemsCenter css={{ justifyContent: 'center', minWidth: 100 }}>
        <Loading size={20} container={false} noTimeout />
      </FlexAlignItemsCenter>
    )
  }
  return (
    <Select
      required={required}
      // label={<Trans>Staff Location</Trans>}
      value={value}
      onValueChange={onChange}
    >
      {!withoutall && <Select.Item value="all">{t`All`}</Select.Item>}
      {!withoutNone && <Select.Item value={0}>{t`No location`}</Select.Item>}
      {planLocations.map(location => {
        return (
          <Select.Item
            key={location.plan_location_id}
            value={location.plan_location_id}
          >
            {location.place}
          </Select.Item>
        )
      })}
    </Select>
  )
}
